/**
* @module FaceIframe
* @author: zhangyemei
* @description: 人脸识别 iframe 
* @since: 2020-10-19 16:28:23
*/
import React, { Component } from 'react';
import { Modal, message, Button, Icon } from 'antd';
import { getFaceVerifyUrl, getResult } from '@/fetch/api/face.js';
import './style.less';
let windowOpenFace = null;
export default class FaceIframe extends Component {
  state = {
    classTypeId: this.props.classTypeId,
    lessonId: this.props.lessonId,
    modalVisible: false
  };

  componentDidMount() {
    // window.faceVerifyCallback = this.faceVerifyCallback;
    this.getFaceVerifyUrlFn();
  }

  componentWillUnmount() {
    console.log(777, 'componentWillUnmount');
  }

  componentWillReceiveProps(prevProps) {
    if (prevProps.classTypeId != this.props.classTypeId) {
      this.setState({
        classTypeId: prevProps.classTypeId,
        lessonId: prevProps.lessonId
      }, () => {
        this.getFaceVerifyUrlFn();
      });
    }
  }

  getFaceVerifyUrlFn = () => {
    getFaceVerifyUrl({
      classTypeId: this.state.classTypeId || 860598,
      lessonId: this.state.lessonId || 3496154
    }).then(res => {
      message.destroy();

      if (res.code == '1') {
        windowOpenFace = window.open('', '_blank');
        this.setState({
          orderNo: res.data.orderNo,
          modalVisible: true
        }, () => {
          // this.getVerifyResult();
          if (windowOpenFace) windowOpenFace.location.href = res.data.url;else window.open(res.data.url, '_blank');
        });
      } else {
        this.props.successCallback(2);
        message.error(res.message);
      }
    });
  }; // getVerifyResult = () => { // 获取人脸验证结果 
  //   this.getVerifyResultTimer = setInterval(() => {
  //     getResult({orderNo: this.state.orderNo}).then(res => {
  //       // res.data 0 继续 1 成功 2失败
  //       if(res.code == '1'){
  //         if(res.data != 0){
  //           this.props.successCallback(res.data);
  //           this.getVerifyResultTimer && clearInterval(this.getVerifyResultTimer);
  //         }
  //       }
  //     })
  //   }, 1000);
  // }

  getVerifyResult = () => {
    // 获取人脸验证结果 
    getResult({
      orderNo: this.state.orderNo
    }).then(res => {
      // res.data 0 继续 1 成功 2失败
      if (res.code == '1') {
        if (res.data == 1) {
          this.props.successCallback(res.data);
        } else {
          this.setState({
            modalVisible: false
          }, () => {
            Modal.confirm({
              zIndex: 9999,
              title: '',
              icon: <Icon data-inspector-line="90" data-inspector-column="20" data-inspector-relative-path="src\\components\\FaceModal\\FaceIframe.jsx" type="exclamation-circle" />,
              content: '当前系统检测未通过人脸识别认证，是否重新认证？',
              okText: '重新认证',
              cancelText: '取消认证',
              onOk: () => {
                this.setState({
                  modalVisible: true
                }, () => {
                  this.getFaceVerifyUrlFn();
                });
              },
              onCancel: () => {
                this.props.successCallback(2);
              }
            });
          });
        }
      }
    });
  };

  render() {
    const {
      visible = false,
      successCallback = () => {}
    } = this.props;
    const {
      modalVisible
    } = this.state;
    return <div data-inspector-line="115" data-inspector-column="6" data-inspector-relative-path="src\\components\\FaceModal\\FaceIframe.jsx">
        {modalVisible && <Modal data-inspector-line="116" data-inspector-column="25" data-inspector-relative-path="src\\components\\FaceModal\\FaceIframe.jsx" zIndex={9999} title='提示' centered width={300} className="face-iframe-com" maskClosable={false} visible={modalVisible} closable={false} footer={[<Button data-inspector-line="125" data-inspector-column="19" data-inspector-relative-path="src\\components\\FaceModal\\FaceIframe.jsx" type="primary" onClick={this.getVerifyResult}>已完成</Button>]}>
            <p data-inspector-line="126" data-inspector-column="12" data-inspector-relative-path="src\\components\\FaceModal\\FaceIframe.jsx">是否完成人脸识别认证？</p>
        </Modal> || null}
      </div>;
  }

}